import { Box, Typography } from "@mui/material";
import { memo } from "react";
import "./HorizontalCard.css";
import { useStyles } from "./HorizontalCard.styles";

const HorizontalCard = ({ Title, Description, url, icon }: any) => {
  const classes = useStyles();
  const handelCardClick = () => {
    window.open(url, "_self");
  };
  return (
    <Box
      className='borderbox'
      onClick={handelCardClick}
      data-testid='dashboard-horizontal-card-click'>
      <Box
        className={classes.backgroundIconImage}
        sx={{
          backgroundImage: `url(${icon})`,
        }}></Box>
      <Box>
        <Box mb={3}>
          <img src={icon} alt={Title} />
        </Box>
        <Typography component='div' variant='h5semibold' className='title'>
          {Title}
        </Typography>
        <Typography component='div' variant='h6regular' className={classes.description}>
          {Description}
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(HorizontalCard);
